import { IDR } from '@/libs/currency'

/* eslint-disable import/prefer-default-export */
export const columnConfig = [
  {
    key: 'name',
    label: 'Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '300px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'spending_category',
    label: 'Kategori Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '220px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
  {
    key: 'total_decline',
    label: 'Total Decline',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => `${value.toLocaleString()}x`,
  },
  {
    key: 'spending',
    label: 'Total Spending',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => IDR(value),
  },
  {
    key: 'balance',
    label: 'Saldo Kartu',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '200px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
    formatter: value => IDR(value),
  },
  {
    key: 'more',
    label: '',
    thStyle: {
      textTransform: 'capitalize',
      fontSize: '13px',
      color: 'black',
      minWidth: '100px',
      textAlign: 'left',
    },
    tdClass: 'text-black',
    thClass: 'font-semibold',
    class: 'p-1',
  },
]
